import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalService } from '../../_shared/services/msal.service';
import { MonitoringService } from '../../_shared/services/monitoring.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private msalSvc: MsalService,
        monitoringService: MonitoringService) {
        monitoringService.logPageView();
    }

    ngOnInit() {
        const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

        // Component has 2 purposes:
        // 1) MSAL Guard redirects here with the page the user wanted to reach in the returnUrl. It requires login first.
        // 2) Azure AD Login redirects back here after a login (specified in the redirectUrl property of the authentication request). 
        //    When requesting a token silently, this page is opened in an iFrame and the response(with token) is intercepted. The page in the iFrame itself is not used.
        const isInIFrame = (window.parent !== window)
        console.info(`Login for ${returnUrl}. Running in iFrame? ${isInIFrame}`);

        if (!isInIFrame && returnUrl) {
            if (this.msalSvc.authenticated) {
                console.info(`Authentication succesful. Redirecting back to ${returnUrl}`);
                this.router.navigate([returnUrl]);
            }
            else {
                console.info(`Not authenticated trying to reach ${returnUrl}, requesting user to login.`);
                this.msalSvc.login();
            }
        }
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/pages/login/login.component.ts